import { render, staticRenderFns } from "./GBMemberListRow.vue?vue&type=template&id=aee4c31a&scoped=true&"
import script from "./GBMemberListRow.vue?vue&type=script&lang=js&"
export * from "./GBMemberListRow.vue?vue&type=script&lang=js&"
import style0 from "./GBMemberListRow.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GBMemberListRow.vue?vue&type=style&index=1&id=aee4c31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee4c31a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon})
